module.exports = __webpack_public_path__ + "static/media/meteringcase04.2d23e837.png";